import { coerce, nullable, unknown } from 'superstruct'

export const defaultedNull = (struct, fallback) =>
  coerce(nullable(struct), unknown(), (value) => {
    const fallback_ = typeof fallback === 'function' ? fallback() : fallback

    if (value === undefined || value === null) {
      return fallback_
    }

    return value
  })
